// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { handleActions } from 'redux-actions';

import {
    GET_DEVICE_ELIGIBILITY_DATA_SUCCESS,
} from './actions';

const INITIAL_STATE = {};

export default handleActions({
    [GET_DEVICE_ELIGIBILITY_DATA_SUCCESS]: (state: any, { payload }) => ({
        ...payload,
    }),
}, INITIAL_STATE);